import React from 'react';

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer__inner">
        <div className="footer__right">
          &copy; {new Date().getFullYear()} MOSU All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
